module.exports = __webpack_public_path__ + "static/media/c-persian.17caa88f.jpg";